import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatosPersonalesRequest } from '../interfaces/datos-personales-request';
import { GeneralResponse } from '../interfaces/general-response';

@Injectable({
  providedIn: 'root'
})
export abstract class DatosPersonalesService {

  abstract getDatosPersonales(): Observable<any>;
  abstract getNacionalidades(): Observable<any>;
  abstract registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any>;
  abstract validaEdicion(): Observable<any>;
  abstract validaCi(rut: number, ci: string, idEjecutivo: number, isMarketplaceSVA:boolean): Observable<GeneralResponse<any>>;

}
